import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

/**
 * Native port of ``cms/blocks/hc-block/hc-block--ceo-message.html``.
 *
 * The legacy ``static_image`` renders EAGER under puppeteer (plain ``<img>``
 * with the static URL); presentational ``width``/``class`` attrs preserved
 * verbatim. Image ``src`` values are built from the reactivated ``STATIC_URL``
 * context (``useStaticURL``) -- byte-identical to the legacy ``{% static %}``
 * output and SSR-safe, unlike a Vite asset import. The legacy title used a
 * mismatched closing tag (``<h2 ...>...</h1>``) -- HTML5 parses the stray
 * ``</h1>`` as closing the open heading, so the DOM is ``<h2>...</h2>``
 * (rendered faithfully here). The legacy ``&nbsp;`` non-breaking spaces are
 * preserved via the ``&nbsp;`` HTML entities in the JSX text below.
 */
export const CeoMessage = (): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <>
            <img
                src={`${staticURL}img/hardcoded/ceo-message-background.png`}
                alt="Scott Thompson"
                width="1920"
                className="hc-block--ceo-message--background"
                loading="lazy"
                decoding="async"
            />

            <h2 className="hc-block--ceo-message--title">
                A&nbsp;Message from&nbsp;Our&nbsp;CEO
            </h2>

            <p className="hc-block--ceo-message--text">
                To our nearly 12,000 employees around the globe, thank you for
                what you do every day to contribute to our continued success.
            </p>

            <div className="hc-block--ceo-message--ceo-sign">
                <figure className="hc-block--ceo-message--ceo-sign--image">
                    <img
                        src={`${staticURL}img/hardcoded/ceo-sign.png`}
                        alt="Scott Thompson"
                        width="144px"
                        loading="lazy"
                        decoding="async"
                    />
                </figure>
                <div className="hc-block--ceo-message--ceo-sign--name">
                    Scott Thompson
                </div>
            </div>
        </>
    );
};
